module.exports = __webpack_public_path__ + "static/media/117.a903472a.jpg";